<template>
  <div>
    <!-- Search Input Fields -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field 
          label="First Name" 
          prepend-inner-icon="mdi-account"
          variant="outlined"
          density="comfortable"
          v-model="search.firstname" 
          @update:modelValue="searchTimeout();"
          @keydown.enter="handleEnterKey()"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field 
          label="Last Name" 
          prepend-inner-icon="mdi-account"
          variant="outlined"
          density="comfortable"
          v-model="search.lastname" 
          @update:modelValue="searchTimeout();"
          @keydown.enter="handleEnterKey()"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <v-switch 
          color="primary" 
          v-model="search.deceased" 
          :label="search.deceased ? 'Deceased Only' : 'All Records'" 
          @change="searchTimeout()"
          density="compact"
          hide-details
        />
      </v-col>
    </v-row>

    <!-- Loading State -->
    <v-row v-if="loading" class="mt-6">
      <v-col>
        <v-skeleton-loader type="card, card" />
      </v-col>
    </v-row>

    <!-- Results Section -->
    <div v-else-if="people.length > 0" class="mt-6">
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-medium mb-4">
            <v-icon class="mr-1" color="success">mdi-check-circle</v-icon>
            Found {{ people.length }} {{ people.length === 1 ? 'record' : 'records' }}
          </div>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12">
          <PersonDialog 
            v-for="person in people.slice((currentpage-1)*5, (currentpage-1)*5+5)" 
            :key="person.id"
            :cemeteries="cemeteries" 
            :person="person" 
          />
        </v-col>
      </v-row>

      <v-row v-if="pages > 1">
        <v-col cols="12" class="d-flex justify-center">
          <v-pagination 
            v-model="currentpage" 
            :length="pages"
            :total-visible="7"
            rounded="circle"
          />
        </v-col>
      </v-row>
    </div>

    <!-- Empty State -->
    <v-row v-else-if="searchExecuted && !loading && people.length === 0" class="mt-6">
      <v-col>
        <v-alert 
          type="info"
          variant="tonal"
          prominent
        >
          <v-alert-title class="text-h6 mb-2">
            <v-icon class="mr-2">mdi-information</v-icon>
            No Records Found
          </v-alert-title>
          <div class="text-body-2">
            We couldn't find any records matching your search. Try:
            <ul class="mt-2 ml-4">
              <li>Checking the spelling</li>
              <li>Using just the first or last name</li>
              <li>Toggling between "Deceased Only" and "All Records"</li>
            </ul>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PersonDialog from './PersonDialog.vue';


export default {
  name: 'SearchComponent',

  components:{
    PersonDialog
  },

  props:{
    cemeteryid : Number
  },

  data: () => ({
    search : {
      firstname : "",
      lastname : "",
      cemeteryid : null,
      deceased : true
    },
    people : [],
    cemeteries : [],
    pages : 0,
    currentpage : 1,
    loading : false,
    lastSearchValue : "",
    searchExecuted : false,
  }),

  created : function(){
    this.search.cemeteryid = this.cemeteryid;
  },

  methods: {
    searchTimeout(){
      clearTimeout(this.searchtimeout);
      this.searchExecuted = false;
      
      // Show loading immediately if there's input
      if(this.search.firstname || this.search.lastname){
        this.loading = true;
      } else {
        this.loading = false;
      }
      
      this.searchtimeout = setTimeout(()=>{
        this.reloadView()
      }, 1000);
    },
    handleEnterKey(){
      const currentValue = this.search.firstname + this.search.lastname;
      if(currentValue.length > 0 && currentValue !== this.lastSearchValue){
        clearTimeout(this.searchtimeout);
        this.reloadView();
      }
    },
    reloadView(){
      this.people = [];
      this.pages = 0;
      this.currentpage = 1;

      if(this.search.firstname == "" && this.search.lastname == ""){
        this.loading = false;
        return;
      }

      this.lastSearchValue = this.search.firstname + this.search.lastname;

      this.loading = true;

      fetch("https://app.cemeterycommunity.com:11000/api/getcemeterieswithgenealogystatus", { method: "POST" })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results == "Failed" ) return;
        else if(res.results == "Failed - Auth") return;
        else this.cemeteries = res.results;
      });
      fetch("https://app.cemeterycommunity.com:11000/api/g-searchpeoplebyname", { method: "POST", headers : { data : JSON.stringify(this.search) } })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results == "Failed" ) return;
        else if(res.results == "Failed - Auth") return;
        else this.people = res.results;

        this.loading = false;
        this.searchExecuted = true;

        this.pages = Math.ceil(this.people.length / 5);
      });
    },
  }
}
</script>